/** A capped multi-select chip group (e.g. Vibe up to 5, Good for up to 5). Optionally supports a
 * brand-safe "add your own" (member-typed chips screened via shared guardrails). */
import { AddYourOwn } from './AddYourOwn.js';

interface MultiSelectProps {
  options: readonly string[];
  selected: string[];
  max: number;
  onToggle: (value: string) => void;
  ariaLabel: string;
  /** When provided, renders an "add your own" input (subject to the same cap). */
  onAddCustom?: (value: string) => void;
}

export function MultiSelect({ options, selected, max, onToggle, ariaLabel, onAddCustom }: MultiSelectProps) {
  const atCap = selected.length >= max;
  const customs = selected.filter((s) => !options.includes(s));

  return (
    <div className="multi-select">
      <div className="chip-row" role="group" aria-label={ariaLabel}>
        {options.map((opt) => {
          const isOn = selected.includes(opt);
          const disabled = atCap && !isOn;
          return (
            <button
              key={opt}
              type="button"
              aria-pressed={isOn}
              disabled={disabled}
              className={`chip${isOn ? ' is-selected' : ''}${disabled ? ' is-disabled' : ''}`}
              onClick={() => onToggle(opt)}
            >
              {opt}
            </button>
          );
        })}
        {customs.map((c) => (
          <button
            key={c}
            type="button"
            aria-pressed={true}
            className="chip is-selected is-custom"
            onClick={() => onToggle(c)}
          >
            {c}
          </button>
        ))}
      </div>
      {onAddCustom && !atCap && <AddYourOwn label={ariaLabel} onAdd={onAddCustom} />}
    </div>
  );
}
